import {
  format_report_question_type,
  is_metric_allowed_for_question,
  is_select_question as is_select_question_helper,
} from "./report_generation_builder_helpers";
import { QUESTION_RESPONSE_SUMMARY } from "./report_generation_builder_constants";

const ANSWER_DEPENDENT_FIELD_NAMES = [
  "selected_entity_count",
  "answer_occurrence_count",
];

/**
 * Selection and question-configuration methods for the report builder.
 */
export default {
  sync_response_summary_answer_fields(changed_field_id) {
    if (this.selected_report_type_internal_name !== QUESTION_RESPONSE_SUMMARY) {
      return;
    }
    const selected_answer_id = this.get_lookup_id("report_fields", "selected_answer");
    const dependent_field_ids = ANSWER_DEPENDENT_FIELD_NAMES.map((field_name) =>
      this.get_lookup_id("report_fields", field_name)
    ).filter(Boolean);
    const has_dependent_fields = dependent_field_ids.some((field_id) =>
      this.selected_field_ids.includes(field_id)
    );
    if (has_dependent_fields && selected_answer_id) {
      if (!this.selected_field_ids.includes(selected_answer_id)) {
        this.selected_field_ids = [selected_answer_id, ...this.selected_field_ids];
      }
      return;
    }
    if (changed_field_id !== selected_answer_id) {
      return;
    }
    this.selected_field_ids = this.selected_field_ids.filter(
      (field_id) => !dependent_field_ids.includes(field_id)
    );
  },
  toggle_entity_type(entity_type_id) {
    const normalized_entity_type_id = this.normalize_id(entity_type_id);
    const is_selected = this.selected_entity_type_ids.includes(
      normalized_entity_type_id
    );
    this.selected_entity_type_ids = is_selected
      ? this.selected_entity_type_ids.filter((id) => id !== normalized_entity_type_id)
      : [...this.selected_entity_type_ids, normalized_entity_type_id];
    this.handle_scope_change();
  },
  toggle_field(field_id) {
    const normalized_field_id = this.normalize_id(field_id);
    const is_selected = this.selected_field_ids.includes(normalized_field_id);
    if (is_selected && normalized_field_id === this.required_field_id) {
      return;
    }
    this.selected_field_ids = is_selected
      ? this.selected_field_ids.filter((id) => id !== normalized_field_id)
      : [...this.selected_field_ids, normalized_field_id];
    if (is_selected) {
      Reflect.deleteProperty(this.field_display_labels, normalized_field_id);
    }
    this.sync_response_summary_answer_fields(normalized_field_id);
  },
  is_question_selected(question_id) {
    return this.selected_questions.some((question) => question.id === question_id);
  },
  toggle_question_selection(question) {
    if (this.is_question_selected(question.id)) {
      this.remove_question(question.id);
      return;
    }
    this.selected_questions = [
      ...this.selected_questions,
      {
        ...question,
        selected_value: "",
        selected_values: [],
        selected_metric_type_ids: this.get_default_metric_type_ids(
          question.question_type
        ),
      },
    ];
  },
  remove_question(question_id) {
    this.selected_questions = this.selected_questions.filter(
      (question) => question.id !== question_id
    );
  },
  format_question_type(question_type) {
    return format_report_question_type(question_type);
  },
  is_select_type(question) {
    return is_select_question_helper(question);
  },
  get_allowed_metric_types(question) {
    return this.report_metric_types.filter((metric_type) =>
      is_metric_allowed_for_question(question, metric_type.internal_name)
    );
  },
  toggle_question_metric(question_id, metric_type_id) {
    const normalized_metric_type_id = this.normalize_id(metric_type_id);
    this.selected_questions = this.selected_questions.map((question) => {
      if (question.id !== question_id) {
        return question;
      }
      const metric_ids = question.selected_metric_type_ids || [];
      const is_selected = metric_ids.includes(normalized_metric_type_id);
      return {
        ...question,
        selected_metric_type_ids: is_selected
          ? metric_ids.filter((id) => id !== normalized_metric_type_id)
          : [...metric_ids, normalized_metric_type_id],
      };
    });
  },
};
